<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-08 15:18:13
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
        :disabled="formDisabled"
      >
        <el-form-item label="商品名称" prop="productName">
          <el-input
            v-model.trim="form.productName"
            placeholder="请输入商品名称"
            maxlength="50"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="原价" prop="productOriginalPrice">
          <el-input
            v-model.trim="form.productOriginalPrice"
            placeholder="请输入价格"
            maxlength="10"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="productPrice">
          <el-input
            v-model.trim="form.productPrice"
            placeholder="请输入价格"
            maxlength="10"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input
            v-model.trim="form.stock"
            placeholder="请输入库存"
            type="number"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否上架" prop="isShow">
          <el-radio-group v-model="form.isShow">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否新品" prop="isNew">
          <el-radio-group v-model="form.isNew">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否热门" prop="isHot">
          <el-radio-group v-model="form.isHot">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品图片" prop="productImage">
          <el-upload
            :class="form.productImage ? 'hide' : 'show'"
            action
            ref="staffImgUpload"
            :file-list="fileList"
            :limit="1"
            :on-exceed="surpass"
            list-type="picture-card"
            :http-request="importFile"
            :on-remove="productImageRemove"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-input v-model="form.productImage" :hidden="true"
          style="position: absolute;width: 0;height: 0;display: none;" /> -->
        </el-form-item>
        <el-form-item label="商品轮播图" prop="sliderImage">
          <el-upload
            :class="bindClass(5, 'sliderImage')"
            action
            multiple
            ref="staffImgUpload"
            :file-list="sliderImageList"
            :limit="5"
            :on-exceed="surpass"
            list-type="picture-card"
            :http-request="sliderImageImportFile"
            :on-remove="sliderImageRemove"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品描述" prop="description">
          <el-input
            v-model.trim="form.description"
            placeholder="请输入价格(长度99字符内)"
            type="textarea"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品详情图片" prop="descriptionImage">
          <el-upload
            :class="bindClass(20, 'descriptionImage')"
            action
            multiple
            ref="staffImgUpload"
            :file-list="descriptionImageList"
            :limit="20"
            :on-exceed="surpass"
            list-type="picture-card"
            :http-request="descriptionImageListImportFile"
            :on-remove="descriptionImageRemove"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-checkbox-group v-model="form.typeIds">
            <el-checkbox
              v-for="(item, index) in shopClassifyList"
              :key="index"
              :label="item.id + ''"
              name="type"
              >{{ item.typeName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <span slot="footer" v-if="!formDisabled">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import { httpAction, uploadAction } from "@/api/manage";

import { listMixin } from "@/mixins/listMixin";

var validateInput = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入名称"));
  }
  let newValue = value.replace(/[<>/\\]/g, "");
  if (newValue !== value) {
    callback(new Error("请勿输入特殊字符"));
  } else {
    callback();
  }
};
export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      formDisabled: false,
      disableMixinCreated: true,
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: { sliderImage: [], descriptionImage: [], typeIds: [] },
      validatorRules: {
        productName: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          { max: 50, message: "长度在 50 个字符以内", trigger: "change" },
          {
            validator: validateInput,
            message: "不可以输入特殊符号",
            trigger: "blur",
          },
        ],
        productOriginalPrice: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { max: 16, message: "长度在16 个字符以内", trigger: "change" },
        ],
        productPrice: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { max: 16, message: "长度在16 个字符以内", trigger: "change" },
        ],
        stock: [{ required: true, message: "请输入库存", trigger: "blur" }],
        isShow: [{ required: true, message: "请选择上架", trigger: "change" }],
        isNew: [
          { required: true, message: "请选择是否新品", trigger: "change" },
        ],
        isHot: [
          { required: true, message: "请选择是否热门", trigger: "change" },
        ],
        productImage: [
          { required: true, message: "请上传商品图片", trigger: "change" },
        ],
        description: [
          { required: true, message: "请输入商品描述", trigger: "blur" },
          { max: 500, message: "长度在 500 个字符以内", trigger: "change" },
          {
            validator: validateInput,
            message: "不可以输入特殊符号",
            trigger: "blur",
          },
        ],
        // sliderImage: [{ required: true, message: "请上传轮播图", trigger: "blur" }],
        // descriptionImage: [{ required: true, message: "请上传商品详情图片", trigger: "blur" }]
      },
      url: {
        add: "/mallProduct/addProduct",
        edit: "/mallProduct/editProduct",
        upload: "/api/upload",
        detail: "/mallProduct/queryProductInfo/",
        queryShopClassify: "/wlMallType/queryPage",
      },
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      sliderImageList: [],
      descriptionImageList: [],
      shopClassifyList: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    bindClass(num, name) {
      if (num <= this.form[name]?.length) return "hide";
      else if (this.formDisabled) return "hide";
      else return "show";
    },
    beforeAvatarUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/bmp", "image/png"];
      const isIMG = types.includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isIMG) {
        this.$message.error("上传图片只能是 JPG、JPEG、bmp、PNG 格式!");
      }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isIMG && isLt10M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    importFile(file) {
      let formData = new FormData();
      formData.append("businessType", 170);
      formData.append("file", file.file, file.file.name); // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功");
          this.form.productImage = res.data[0];
          this.$refs["form"].clearValidate("productImage");
        })
        .catch((err) => {
          this.$message.error("上传失败");
        });
    },
    sliderImageImportFile(file) {
      let formData = new FormData();
      formData.append("businessType", 170);
      formData.append("file", file.file, file.file.name); // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功");
          this.sliderImageList.push({ uid: res.data[0], url: res.data[0] });
          this.form.sliderImage = this.sliderImageList.map(function (item) {
            return item.url;
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("上传失败");
        });
    },
    descriptionImageListImportFile(file) {
      let formData = new FormData();
      formData.append("businessType", 170);
      formData.append("file", file.file, file.file.name); // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功");
          this.descriptionImageList.push({
            uid: res.data[0],
            url: res.data[0],
          });
          this.form.descriptionImage = this.descriptionImageList.map(function (
            item
          ) {
            return item.url;
          });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("上传失败");
        });
      // let formData = new FormData()
      // formData.append("businessType", 170)
      // formData.append("file", file.file, file.file.name) // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      // uploadAction(this.url.upload, formData)
      //   .then((res) => {
      //     console.log(res.data)
      //     this.$message.success("上传成功")
      //     this.form.descriptionImage.push(res.data[0])
      //     console.log(this.form.descriptionImage)
      //   })
      //   .catch((err) => {
      //     this.$message.error("上传失败")
      //   })
    },
    productImageRemove() {
      this.form.productImage = "";
    },
    sliderImageRemove(e) {
      console.log(e);
      console.log(this.sliderImageList);
      this.form.sliderImage = this.form.sliderImage.filter(
        (item) => item !== e.url
      );
      this.sliderImageList = this.sliderImageList.filter(
        (item) => item.url !== e.url
      );
      console.log(this.form);
    },
    descriptionImageRemove(e) {
      this.form.descriptionImage = this.form.descriptionImage.filter(
        (item) => item !== e.url
      );
      this.descriptionImageList = this.descriptionImageList.filter(
        (item) => item.url !== e.url
      );
    },
    surpass() {
      this.$message.warning("图片超过限定张数!");
    },
    add() {
      this.edit();
    },
    edit(record, type) {
      httpAction(this.url.queryShopClassify, {}, "post").then((res) => {
        console.log(res);
        if (res.code !== 200) return this.$message.warning(res.msg);
        this.shopClassifyList = res.data.records;
        console.log(this.shopClassifyList);
      });
      this.formDisabled = type;
      record &&
        httpAction(this.url.detail + record.id, {}, "get").then((res) => {
          if (res.code === 200) {
            const typeIds = res.data.typeIds.map(item => item.toString())
            this.form = res.data;
            this.form.typeIds = typeIds
            // this.form = Object.assign({}, res.data)
            this.form.productPrice = this.form.productPrice + "";
            this.form.productOriginalPrice =
              this.form.productOriginalPrice + "";
            this.$refs["form"].clearValidate("productImage");
            this.fileList.push({ uid: 0, url: res.data.productImage || "" });
            res.data.sliderImage &&
              res.data.sliderImage.forEach((item, index) => {
                this.sliderImageList.push({ uid: index, url: item });
              });
            res.data.descriptionImage &&
              res.data.descriptionImage.forEach((item, index) => {
                this.descriptionImageList.push({ uid: index, url: item });
              });
          }
        });
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.form = { sliderImage: [], descriptionImage: [], typeIds: [] };
      this.fileList = [];
      this.sliderImageList = [];
      this.descriptionImageList = [];
      this.shopClassifyList = [];
      this.$emit("close");
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs["form"].clearValidate("productImage");
          that.confirmLoading = true;
          let httpurl = "";
          let method = "";
          const parms = { ...this.form };
          if (!this.form.id) {
            httpurl += this.url.add;
            method = "post";
          } else {
            httpurl += this.url.edit;
            method = "post"; //put
            parms.userId = this.form.id;
          }
          httpAction(httpurl, parms, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success("操作成功");
                that.$emit("ok");
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.show /deep/ .el-upload--picture-card {
  display: block;
}
</style>
